import React, { useEffect} from 'react';
import clsx from 'clsx';
import {
    ServiceDialog,
    ConfirmButton,
} from '../../../styling/Styles';
import {
    checkExistDataElementName,
    checkIfEmpty,
    checkHasSpaces
} from '../../../validations/validations';
import FormDataElement from './FormDataElement';
import ListDataElement from './ListDataElement';
import DropdownMechanism from "../../GeneralComponents/DropdownMechanism";
import CreateDataElementSnackBar from '../../CreateDataElementSnackBar';

/**
 * @param {boolean} props.openAlert - state to open/close edit data element pop up
 * @param {setState} props.setOpenAlert - hook method that handle openAlert variabel
 * @param {Object} props.editor - grapesJs editor
 * @param {number} props.selectedProject - index of user's selected project stored in local storage
 * @param {number} props.indexEditBlockDataElement - index of stored data element
 * @param {setState} props.setIndexEditBlockDataElement - hook method that handle indexEditBlockDataElement
 * @param {boolean} props.clickedEditBlockDataElement - state that shows if pop up has opened to edit an existing data element or to create one
 * @param {setState} props.setClickedEditBlockDataElement - hook method that handle clickedEditBlockDataElement
 * @param {boolean} props.editDataElementType - type of edited data element ( list , form )
 * @param {setState} props.setRenderAgain - handle hook variable renderAgain
 * @param {method} props.savedPageClicked - saves page of current project
 * @returns general pop up that edit/create data element
 */
const DataElelementPopUpWindow = (props) => {

    const {
        openAlert,
        setOpenAlert,
        editor,
        selectedProject,
        indexEditBlockDataElement,
        setIndexEditBlockDataElement,
        clickedEditBlockDataElement,
        setClickedEditBlockDataElement,
        editDataElementType,
        setRenderAgain,
        savedPageClicked
    }= props;
    const dataElementsTypes =['form','list'];
    const [typeDataElement, setTypeDataElement] = React.useState('form'); // current data element type
    const [components, setComponents] = React.useState([]); // components of data element
    const [typeFields, setTypeFields] = React.useState(['input','input','checkbox','textarea','button']) // type of components to add in rows of data elements
    const [init,setInit] = React.useState(false); // init of open 
    const [dataElementName, setDataElementName] = React.useState('') // name of current data element
    const [openSnackBar, setOpenSnackBar] = React.useState(false); // open/close snackbar
    const [clickedList, setClickedList] = React.useState(false); // update list components
    const [clickedGenerateBlock, setClickedGenerateBlock] = React.useState(false); // fire generation of block
    
    /**
     * Initialize general info for data element
     */
    useEffect( () =>{
        // Initialize new data element
        if(init === false || openAlert === true && clickedEditBlockDataElement !== true){
            const tempComponents=[];
            setInit(true);
            setComponents(tempComponents);
            setTypeFields([]);
            setTypeDataElement('form');
            setClickedGenerateBlock(false);
            
        }
        // Initialize edit data element
        else if(openAlert === true && clickedEditBlockDataElement === true){
            const tempData = JSON.parse(localStorage.getItem('data'));
            const tempTypeFields = tempData[selectedProject].data_elements.data_elements_info[indexEditBlockDataElement].typeFields;
            const tempName = tempData[selectedProject].data_elements.data_elements_info[indexEditBlockDataElement].dataName;
            const tempComponents = tempData[selectedProject].data_elements.data_elements_info[indexEditBlockDataElement].components;
            setTypeDataElement(editDataElementType);
            setTypeFields(tempTypeFields);
            setDataElementName(tempName);
            setComponents(tempComponents);
            setClickedGenerateBlock(false);
        }   
    },[init,openAlert])


    // close data element pop up
    const handleCancel = () => {
        setOpenAlert(false);
        setClickedEditBlockDataElement(false);
        setClickedList(false);
        setIndexEditBlockDataElement(-1);
    }

    /**
     * @param {string} option - data element type
     * @returns method that update data element type of examined pop up
     */
    const selectTypeDataElement  = (option) => {
        setTypeDataElement(option);
        if(option === 'list'){
            setClickedList(true);
        }
        setTypeFields([]);
        setComponents([]);
    }

    // Update/create data element 
    const createBoxDataElement = () =>{
        if(checkIfEmpty(dataElementName) === false && checkHasSpaces(dataElementName) === false && checkExistDataElementName(dataElementName,selectedProject,indexEditBlockDataElement) === false){
            setClickedGenerateBlock(true);
            setOpenSnackBar(true);
            setOpenAlert(false);
            setClickedList(false);
            setRenderAgain(true);
        }
    }

    return(
        <>
             <ServiceDialog
                open={openAlert}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <div style={{'maxHeight': '80vh',overflow: 'hidden'}}>
                    <div className={clsx('titlePopUp','paddingTitle')} style={{minWidth: '800px'}}> 
                        Generate new data element wrapper & data element block
                        <div onClick={handleCancel} className={clsx('pop-up-close-btn')} aria-hidden="true">x</div>
                    </div>
    
                    <div className={clsx('paddingTitle')} style={{maxHeight: '60vh', overflow: 'auto'}}> 
                    <div className ={clsx('spacingTopDiv','flexRowDirection')}>
                        <span>Select type of data element:&nbsp; </span>
                        <DropdownMechanism
                            target={typeDataElement}
                            targets={dataElementsTypes}
                            selectTarget={selectTypeDataElement}
                        />
                    </div>
                    { typeDataElement === 'form' &&
                        <FormDataElement
                            typeFields ={typeFields}
                            setTypeFields ={setTypeFields}
                            components={components}
                            setComponents={setComponents}
                            dataFormName={dataElementName}
                            setDataFormName={setDataElementName}
                            openAlert={openAlert}
                            selectedProject={selectedProject}
                            clickedEditBlockDataElement={clickedEditBlockDataElement}
                            indexEditBlockDataElement={indexEditBlockDataElement}
                            clickedGenerateBlock={clickedGenerateBlock}
                            setClickedGenerateBlock={setClickedGenerateBlock}
                            editor={editor}
                            savedPageClicked={savedPageClicked}
                        />
                    }     
                    { typeDataElement === 'list' &&
                        <ListDataElement 
                            selectedProject={selectedProject}
                            clickedEditBlockDataElement={clickedEditBlockDataElement}
                            dataListName={dataElementName}
                            indexEditBlockDataElement={indexEditBlockDataElement}
                            setDataListName={setDataElementName}
                            clickedList={clickedList}
                            editor={editor}
                            clickedGenerateBlock={clickedGenerateBlock}
                            setClickedGenerateBlock={setClickedGenerateBlock}
                            components={components}
                            setComponents={setComponents}
                            typeFields ={typeFields}
                            setTypeFields ={setTypeFields}
                            savedPageClicked={savedPageClicked}
                        />
                    }
                    
                </div>
                <div className={clsx('flex-container', 'spacingDownDiv', 'spacingTopDiv','paddingTitle')} 
                            style={{
                                justifyContent: "flex-end",
                                display: 'flex',
                                flexDirection: 'row'
                            }}

                        >
                        <div>
                            <ConfirmButton 
                                onClick ={ createBoxDataElement}
                            >
                                Generate
                            </ConfirmButton>
                        
                        </div>


                    </div>
                </div>            
            </ServiceDialog>
            <CreateDataElementSnackBar
                open={openSnackBar}
                setOpen={setOpenSnackBar}
                isEdit={clickedEditBlockDataElement}
            />
        </>

    )

}

export default DataElelementPopUpWindow;